import React from "react";
import { Link } from "react-router-dom";
function Sidebar(props) {
    return (
        <>
            <ul className="list-group text-start" style={{minHeight:"110vh"}}>
                {props.list.map((listItems) => (
                    listItems.subcategory !== undefined ? <li className='list-group-item border-0'>
                        <div className="dropdown">
                            <button className="btn dropdown-toggle border-0 p-0" type="button" data-bs-toggle="dropdown" >
                                {listItems.category}
                            </button>
                            <ul className="dropdown-menu translate-0 border-0 position-relative mt-0">
                                {listItems.subcategory.map((subcategory) => (<li className="dropdown-item" ><Link className="link-hide"to={subcategory.route}>{subcategory.name}</Link></li>))}
                            </ul>
                        </div>
                    </li> :<Link className="link-hide" to={listItems.route} ><li className="list-group-item border-0"> {listItems.category}</li></Link>
                ))}
            </ul>
        </>
    )
}
export default Sidebar;